import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payout"
export default class extends Controller {
  static values = { fee: Object }
  static targets = [ "input" ]

  connect() {
  }

  change(event) {
    this.amount = event.currentTarget.value

    switch (this.feeValue.operator) {
      case "integer":
        this.payout = this.amount - this.feeValue.amount
        break
      case "percentage":
        this.payout = this.amount - (this.amount * this.feeValue.amount / 100)
        break
      case "none":
        this.payout = this.amount
        break
    }

    // this.payoutが0以下の場合は0にする
    if (this.payout <= 0) {
      this.payout = 0
    }

    this.inputTarget.value = (this.payout) / 10
  }
}
